import { Component } from '@angular/core';

/**
 * Üç yasal metin arasındaki çapraz bağlantılar. routerLinkActive sayesinde
 * bulunulan sayfa kendini pasif gösterir, dolayısıyla tek bir örnek üç
 * sayfada da girdi almadan çalışır.
 */
@Component({
  selector: 'app-legal-links',
  templateUrl: './legal-links.component.html'
})
export class LegalLinksComponent {}
